import FlexWrap from '@/components/common/FlexWrap';
import InnerLayout from '@/components/common/InnerLayout';
import ReceiptLayout from '@/components/MedicalReceipt/ReceiptLayout';
import { useAppSelector } from '@/hooks/useReduxHooks';
import { routes } from '@/constant/routes.const';
import { useHistory } from 'react-router-dom';
import styled from 'styled-components';
import TextButton from '@/components/common/TextButton';
import {
  ICON_AIRPLANE,
  IMG_BANNER,
  IMG_GUIDE_KOR1,
  IMG_GUIDE_KOR5,
  IMG_GUIDE_KOR7,
} from '@repo/assets';

const MedicalRefundProcedure = () => {
  const { nationality } = useAppSelector((state) => state);
  const history = useHistory();

  const goToHome = () => {
    history.push(routes.medicalHome);
  };

  return (
    <ReceiptLayout hasPadding={false}>
      <Banner dir='column' alignItems='center'>
        <BannerSubTitle>간편한 모바일</BannerSubTitle>
        <BannerTitle>KTP 택스 리펀</BannerTitle>
        <BannerImg src={IMG_BANNER} />
      </Banner>
      <Container>
        <Inner>
          <Title>
            {nationality === 'KOR'
              ? 'KTP 택스리펀 프로세스'
              : 'Tax Refund Process'}
          </Title>
          <Content>
            <Indicator src={ICON_AIRPLANE} />
            <Step>{nationality === 'KOR' ? '첫 번째' : 'STEP 1'}</Step>
            <SubTitle>송금정보 입력</SubTitle>
            <ContentText>
              KTP 송금 택스 리펀으로 공항에서 시간을 절약하세요. 물품 구매 후
              3개월 이내에 송금 받을 계좌 정보를 정확히 입력해주세요.
            </ContentText>
            <ContentImage src={IMG_GUIDE_KOR1} />
            <Step>{nationality === 'KOR' ? '두 번째' : 'STEP 2'}</Step>
            <SubTitle>출국 확인 (출입국사실증명)</SubTitle>
            <ContentText>
              출국 후 1주일이 경과한 시점에 출입국사실증명서를 다운로드받아
              KTP웹에 업로드해주세요.
            </ContentText>
            <ContentImage src={IMG_GUIDE_KOR7} />
            <Step>{nationality === 'KOR' ? '마지막' : 'STEP 3'}</Step>
            <SubTitle>환급액 송금</SubTitle>
            <ContentText>
              계좌 입력 및 출국 확인이 완료되면 환급액을 송금합니다. 환급액
              송금까지 출국 후 영업일 기준 21일 정도 소요됩니다.
            </ContentText>
            <ContentImage src={IMG_GUIDE_KOR5} />
          </Content>
        </Inner>
        <BtnWrapper>
          <TextButton
            title={
              nationality === 'KOR' ? '지금 환급받기' : 'Get Tax Refund Now'
            }
            onClick={goToHome}
          />
        </BtnWrapper>
      </Container>
    </ReceiptLayout>
  );
};

export default MedicalRefundProcedure;

const Banner = styled(FlexWrap)`
  background-color: #f4f8ff;
  height: 100%;
  width: 375px;
  overflow: hidden;
  @media ${(props) => props.theme.mobile} {
    width: 100%;
    margin-top: -8px;
  }
`;

const BannerImg = styled.img`
  width: 110%;
`;

const BannerSubTitle = styled.h3`
  color: #3a3b3e;
  font-size: 18px;
  margin-top: 44px;
  line-height: 150%;
`;

const BannerTitle = styled.h2`
  color: #246cf6;
  font-size: 36px;
  line-height: 150%;
  font-weight: 700;
`;

const Container = styled.div`
  position: relative;
  width: 100%;
  background-color: #fff;
  border-radius: 20px;
  -webkit-box-shadow: 0px 20px 20px -20px rgba(174, 191, 204, 0.5);
  box-shadow: 0px 0px 20px 0px rgba(174, 191, 204, 0.5);
`;

const Inner = styled(InnerLayout)`
  background-color: #fff;
`;

const Title = styled.h2`
  font-size: 24px;
  line-height: 150%;
  margin: 56px auto 44px 20px;
  font-weight: 700;
`;

const SubTitle = styled.h3`
  font-size: 18px;
  line-height: 150%;
  margin-bottom: 12px;
  font-weight: 700;
`;

const Content = styled.div`
  display: flex;
  flex-direction: column;
  padding: 0 20px 0 24px;
  margin-left: 20px;
  border-left: 4px solid #d9d9d9;
`;

const Step = styled.span`
  color: #fff;
  background-color: #246cf6;
  font-size: 14px;
  line-height: 21px;
  padding: 4px 0;
  text-align: center;
  border-radius: 100px;
  width: 80px;
  margin-bottom: 20px;
`;

const ContentText = styled.p`
  font-size: 13px;
  line-height: 150%;
  margin-bottom: 12px;
  white-space: pre-wrap;
  word-break: keep-all;
`;

const WarnningPoint = styled.span`
  display: block;
  margin-top: 5px;
  color: #ed0828;
  font-size: 13px;
  font-weight: 400;
`;

const ContentImage = styled.img`
  width: 100%;
  margin-bottom: 44px;
`;

const Indicator = styled.img`
  width: 20px;
  height: 20px;
  position: absolute;
  left: 12px;
  top: 150px;
`;

const BtnWrapper = styled.div`
  padding: 20px;
  background-color: #fff;
`;
